<template>
  <div class="query-test-section">
    <div class="field">
      <button
        type="button"
        class="button is-info"
        :class="{ 'is-loading': loading }"
        :disabled="!canTest || loading"
        @click="testQuery"
      >
        <octicon :icon="search" /> <span>{{ $t('apiChannel.testQuery') }}</span>
      </button>
    </div>

    <div v-if="result" class="query-result">
      <div v-if="result.success" class="notification is-success is-light">
        <p><strong>{{ $t('apiChannel.logsFound', { total: result.total.toLocaleString() }) }}</strong></p>
        <div v-if="result.logs && result.logs.length > 0" class="logs-preview">
          <table class="table is-narrow is-fullwidth is-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>{{ $t('apiChannel.logPreview') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(log, index) in result.logs" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <code class="log-content">{{ formatLog(log) }}</code>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="notification is-danger is-light">
        <p><strong>{{ $t('apiChannel.queryError') }}</strong></p>
        <p>{{ result.error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { search } from 'octicons-vue'

export default {
  name: 'QueryTestSection',
  props: {
    indexId: {
      type: String,
      default: ''
    },
    query: {
      type: String,
      default: ''
    },
    schedule: {
      type: String,
      default: '5m'
    }
  },
  data () {
    return {
      loading: false,
      result: null
    }
  },
  computed: {
    search () {
      return search
    },
    canTest () {
      return this.indexId
    }
  },
  watch: {
    indexId () {
      this.result = null
    },
    query () {
      this.result = null
    },
    schedule () {
      this.result = null
    }
  },
  methods: {
    testQuery () {
      if (!this.canTest) return

      this.loading = true
      this.result = null

      this.$http.post('/api/v1/api-channels/test-query', {
        index_id: this.indexId,
        query: this.query || '',
        schedule: this.schedule || '5m'
      }).then(response => {
        if (response && response.data && response.data.data) {
          this.result = response.data.data
        }
      }).catch(error => {
        this.result = {
          success: false,
          error: error.response?.data?.message || error.message || 'Unknown error'
        }
      }).finally(() => {
        this.loading = false
      })
    },
    formatLog (log) {
      if (typeof log === 'object') {
        const str = JSON.stringify(log)
        return str.length > 200 ? str.substring(0, 200) + '...' : str
      }
      return String(log)
    }
  }
}
</script>

<style scoped>
.query-test-section {
  margin-top: 1rem;
}
.query-result {
  margin-top: 1rem;
}
.logs-preview {
  margin-top: 0.5rem;
  max-height: 300px;
  overflow-y: auto;
}
.log-content {
  font-size: 0.75rem;
  word-break: break-all;
  white-space: pre-wrap;
}
</style>
